<template>
  <div>
    <b-container class="about-us">
      <b-row>
        <b-col cols="12" sm="8">
          <article class="inner-box mb" v-for="item in about" :key="item.id">
            <h2 class="styled-title">{{ item.title }}</h2>
            <div class="text">
              <div v-html="item.description"></div>
            </div>
          </article>
        </b-col>
        <b-col sm="4">
          <article class="inner-box mb" v-for="item in mv" :key="item.sortId">
            <h2 class="styled-title">{{ item.title }}</h2>
            <div class="text">
              <div v-html="item.description"></div>
            </div>
          </article>
          <article class="inner-box mb">
            <h2 class="styled-title">Our Core Values</h2>
            <div class="text" v-for="item in coreValues" :key="item.sortId">
              <h5>{{ item.title }}</h5>
            </div>
          </article>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" class="mb">
          <h2 class="styled-title">{{ boardTitle }}</h2>
          <p>{{ boardDesc }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4" style="margin:0 auto;">
          <div class="team-grids">
            <div v-for="item in board" :key="item.sortId">
              <b-row>
                <b-col cols="5" sm="4">
                  <div class="pic clickable" @click="loadMember(item)">
                    <div class="stack">
                      <img
                        :src="item.photoURL"
                        alt=" "
                        class="img-responsive"
                      />
                    </div>
                  </div>
                </b-col>
                <b-col cols="7" sm="8">
                  <div class="text-center pl">
                    <h5 class="clickable" @click="loadMember(item)">
                      {{ item.name }}
                    </h5>
                    <div class="designation">
                      <p>{{ item.designation }}</p>
                    </div>
                    <div class="knowmore">
                      <span class="clickable" @click="loadMember(item)">
                        {{ buttonName }}
                        <b-icon icon="arrow-right"></b-icon>
                      </span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>

            <div class="clearfix"></div>
          </div>
        </b-col>
      </b-row>
      <b-row style="margin-top: 30px">
        <b-col cols="12" sm="4" v-for="item in boards" :key="item.sortId">
          <div class="team-grids" style="margin-top: 30px">
            <b-row>
              <b-col cols="5" sm="4">
                <div class="pic clickable" @click="loadMember(item)">
                  <div class="stack">
                    <img :src="item.photoURL" alt=" " class="img-responsive" />
                  </div>
                </div>
              </b-col>
              <b-col cols="7" sm="8">
                <div class="text-center pl">
                  <h5 class="clickable" @click="loadMember(item)">
                    {{ item.name }}
                  </h5>
                  <div class="designation">
                    <p>{{ item.designation }}</p>
                  </div>
                  <div class="knowmore">
                    <span class="clickable" @click="loadMember(item)">
                      {{ buttonName }}
                      <b-icon icon="arrow-right"></b-icon>
                    </span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row style="margin-top: 100px">
        <b-col sm="12" class="mb">
          <h2 class="styled-title">{{ teamTitle }}</h2>
          <p>{{ teamDesc }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" sm="4" v-for="item in team" :key="item.sortId">
          <div class="team-grids" style="margin-top: 30px">
            <b-row>
              <b-col cols="5" sm="4">
                <div class="pic clickable" @click="loadMember(item)">
                  <div class="stack">
                    <img :src="item.photoURL" alt=" " class="img-responsive" />
                  </div>
                </div>
              </b-col>
              <b-col cols="7" sm="8">
                <div class="text-center pl">
                  <h5 class="clickable" @click="loadMember(item)">
                    {{ item.name }}
                  </h5>
                  <div class="designation">
                    <p>{{ item.designation }}</p>
                  </div>
                  <div class="knowmore">
                    <span class="clickable" @click="loadMember(item)">
                      {{ buttonName }}
                      <b-icon icon="arrow-right"></b-icon>
                    </span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      size="xl"
      ref="member-modal"
      hide-footer
      title="Profile Information"
    >
      <div class="d-block">
        <b-row style="margin-bottom: 30px;">
          <b-col sm="2">
            <div class="stack">
              <img
                :src="item.photoURL"
                alt="Pics"
                height="80"
                class="img-responsive"
              />
            </div>
          </b-col>
          <b-col sm="10">
            <h3>{{ item.name }}</h3>
            <p>{{ item.designation }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <div v-html="item.profile"></div>
          </b-col>
        </b-row>
      </div>

      <b-button class="mt-3" variant="outline-danger" block @click="hideModal">
        Done
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { db } from "../firebase/db";
export default {
  data() {
    return {
      drawer: true,
      buttonName: "View Profile",
      boardTitle: "Board of Directors",
      boardDesc:
        "The Board of Directors at ICMS comprises of seven members and is led by Mr. Charles Nwodo Jnr, a seasoned entrepreneur who also serves as the Executive Chairman of ICMS Limited.",
      teamTitle: "Management Team",
      teamDesc:
        "The Management Team responsible for implementing the company's strategies and objectives, is led by Mr. Fidelis Omachonu, the Managing Director.",
      about: [],
      mv: [],
      coreValues: [],
      board: [],
      boards: [],
      team: [],
      item: []
    };
  },
  methods: {
    loadMember(item) {
      this.$refs["member-modal"].show();
      this.item = item;
    },
    hideModal() {
      this.$refs["member-modal"].hide();
    }
  },
  firestore: {
    about: db.collection("aboutUs"),
    coreValues: db.collection("coreValues").orderBy("sortId"),
    mv: db.collection("missionVision"),
    boards: db
      .collection("board")
      .where("sortId", ">", 1)
      .orderBy("sortId"),
    board: db.collection("board").where("sortId", "==", 1),
    team: db.collection("team").orderBy("sortId")
  }
};
</script>

<style lang="scss" scoped>
.about-us {
  padding: 40px;
}
.mb-60 {
  margin-bottom: 60px;
}
.mb-30 {
  margin-bottom: 30px;
}
.mv {
  margin: 40px 0;
}

.knowmore {
  font-size: 16px;
  color: #af0000;
  position: relative;
  line-height: 14px;
  margin: 1px !important;
  text-transform: uppercase;
  cursor: pointer;
}

.team-grid {
  text-align: center;
}
/*-- Team --*/

.team-grid {
  text-align: center;
}

.team-grid h4 {
  font-size: 30px;
  color: #363636;
  font-weight: 600;
  margin: 40px 0 20px;
}

.team-grid p {
  color: #636363;
  font-size: 20px;
  margin-top: -20px;
}

.model-3d-0 a {
  background: #5c5b5b;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
  -o-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.model-3d-0 .front,
.model-3d-0 .back {
  width: 30px;
  height: 30px;
  font-size: 1em;
  color: #fff;
  background: #faad81;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-transform: translateZ(18px);
  -moz-transform: translateZ(18px);
  -ms-transform: translateZ(18px);
  -o-transform: translateZ(18px);
  transform: translateZ(18px);
  -webkit-backface-visibility: visible;
  -moz-backface-visibility: visible;
  -ms-backface-visibility: visible;
  -o-backface-visibility: visible;
  backface-visibility: visible;
}

.model-3d-0 .back {
  font-size: 1em;
  color: #fff;
  -webkit-transform: rotateX(90deg) translateZ(18px);
  -moz-transform: rotateX(90deg) translateZ(18px);
  -ms-transform: rotateX(90deg) translateZ(18px);
  -o-transform: rotateX(90deg) translateZ(18px);
  transform: rotateX(90deg) translateZ(18px);
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
}

.model-3d-0 a:hover {
  -webkit-transform: rotateX(-90deg);
  -moz-transform: rotateX(-90deg);
  -ms-transform: rotateX(-90deg);
  -o-transform: rotateX(-90deg);
  transform: rotateX(-90deg);
}

.model-3d-0 a:hover .back {
  -webkit-backface-visibility: visible;
  -moz-backface-visibility: visible;
  -ms-backface-visibility: visible;
  -o-backface-visibility: visible;
  backface-visibility: visible;
}

.pl {
  padding: 2px 5px 2px 15px;
}
.pl h5 {
  font-size: 18px;
}
.pl .designation {
  min-height: 60px;
  font-size: 14px;
}
.pl .designation p {
  text-align: center !important;
}
.pl .knowmore {
  font-size: 11px;
}

.stack img {
  width: 120px;
  height: 120px;
  vertical-align: bottom;
  border: 5px solid #efefef;
  border-radius: 100px;
  -webkit-border-radius: 100px;
  -o-border-radius: 100px;
  -ms-border-radius: 100px;
  -moz-border-radius: 100px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -o-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -ms-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
}

.stack:last-of-type {
  margin-right: 0;
}

.stack:before {
  top: 4px;
  z-index: -10;
}

/* 1st element in stack (behind image) */

.stack:after {
  top: 8px;
  z-index: -20;
}

/* 2nd element in stack (behind image) */

.stack {
  float: none;
  width: 92%;
  margin: 3% 0% 8% 4%;
  position: relative;
  z-index: 1;
}

.card {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: -1px 2px 4px rgba(0, 0, 0, 0.25), 1px 1px 3px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  max-width: 340px;
}

.card-media {
  width: 100%;
}

.card-details {
  padding: 5px 15px;
}

.card-head {
  font-weight: 400;
}

.card-head {
  font-size: 26px;
  margin-bottom: 15px;
}

.card-action-button {
  border-radius: 2px;
  color: #ffab40;
  cursor: pointer;
  display: inline-block;
  font-weight: 500;
  margin: 0;
  padding: 10px;
  text-decoration: none;
}

.card-action-button:hover {
  background-color: rgba(255, 168, 58, 0.2);
}
.icmspic {
  padding: 120px 0 0 0;
  height: 100%;
}
.icmsinfo {
  padding: 4px;
}
.icmsinfo .midtext {
  font-family: "Red Rose", cursive;
  font-size: 30px;
  color: #323232;
  line-height: 42px;
  margin: 0 0 12px 0;
}
.icmsinfo .bigtext {
  font-family: "Red Rose", cursive;
  font-size: 30px;
  color: #333;
  line-height: 50px;
  margin: 0 0 20px 0;
  font-weight: 600;
}
.icmsinfo .smalltext {
  font-size: 17px;
  line-height: 22px;
  color: #323232;
  width: 95%;
}
.companyglance {
  margin: 50px 0 0 0;
}
.compglancetxt {
  font-size: 30px;
  color: #323232;
  font-family: "Red Rose", cursive;
}
.glancegroup {
  margin: 30px 0 0 0;
}
.glanceitem {
  display: inline-block;
  vertical-align: top;
  margin: 0 42px 0 0;
  padding: 0 42px 0 0;
  border-right: 1px solid #b0bec5;
}
.glancenumber {
  color: #af0000;
  font-size: 48px;
  font-family: "Red Rose", cursive;
}
.glancetxt {
  font-size: 14px;
  font-family: "Red Rose", cursive;
  text-transform: uppercase;
  color: #263238;
}
.glanceitem:last-child {
  border-right: 0;
  padding: 0;
  margin: 0;
}
</style>
